import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';

import { FormattedMessage } from 'react-intl';

const SummaryHeader = styled.div`
  @media (max-width: 767px) {
    display: ${(props) => (props.hideOnMobile ? 'none' : 'block')};
  }
`;

class CheckoutSummaryHeader extends React.Component {
  static displayName = 'CheckoutSummaryHeader';

  static propTypes = {
    tour_name_translation: PropTypes.string.isRequired,
    guide_full_name: PropTypes.string.isRequired,
    tour_id: PropTypes.number,
    is_invoice: PropTypes.bool,
    has_resource: PropTypes.bool,
    resource_name: PropTypes.string,
  };

  static defaultProps = {
    tour_id: null,
    is_invoice: false,
    has_resource: false,
  };

  _tourTitle = () => {
    return <div>{this.props.tour_name_translation}</div>;
  };

  _invoiceId = () => {
    return (
      <h4 className="InvoiceId item-subtitle">
        Invoice # {this.props.tour_id}
      </h4>
    );
  };

  render() {
    const {
      guide_full_name,
      has_resource,
      resource_name,
      is_invoice,
      for_custom_booking,
    } = this.props;

    let headerCSSClass = 'CheckoutSummary-ContentBox Summary-Header';
    if (is_invoice) headerCSSClass += ' invoice';

    return (
      <SummaryHeader hideOnMobile={true} className={headerCSSClass}>
        <h3 className="TourTitle item-title">{this._tourTitle()}</h3>
        <p className="GuideName item-subtitle">
          <FormattedMessage
            id="WITH_NAME"
            defaultMessage="With {name}"
            values={{ name: has_resource ? resource_name : guide_full_name }}
          />
        </p>
        {is_invoice ? this._invoiceId() : null}
      </SummaryHeader>
    );
  }
}

export default CheckoutSummaryHeader;
